import axios from "axios";
import { type IHotelState } from "./hotelInterface";
import {
  type IBookingState,
  type IBookingReservation,
} from "../booking/bookingInterface";

/**
 * Get hotel configuration to set room categories and products
 *
 * @param Id
 * @param ConfigurationId
 * @returns
 */
export function fetchHotelConfiguration(Hotel: IHotelState, Id: IHotelState["Id"]) {
  return axios({
    method: "post",
    url: import.meta.env.VITE_MEWS_API_URL + "hotels/get",
    data: {
      Client: import.meta.env.VITE_MEWS_API_CLIENT,
      LanguageCode: Hotel.Culture.LanguageCode,
      CultureCode: Hotel.Culture.CultureCode,
      HotelId: Id,
    },
  });
}

/**
 * Get hotel payment configuration to set room categories and products
 *
 * @param Id
 * @param ConfigurationId
 * @returns
 */
export function fetchHotelPaymentConfiguration(
  Hotel: IHotelState, Id: IHotelState["Id"]) {
  return axios({
    method: "post",
    url: import.meta.env.VITE_MEWS_API_URL + "hotels/getPaymentConfiguration",
    data: {
      Client: import.meta.env.VITE_MEWS_API_CLIENT,
      LanguageCode: Hotel.Culture.LanguageCode,
      CultureCode: Hotel.Culture.CultureCode,
      HotelId: Id,
    },
  });
}

/**
 * Get room availability, occupancy and prices by date
 * @param Id
 * @param StartUtc
 * @param EndUtc
 * @returns
 */
export function fetchHotelRoomAvailability(
  Hotel: IHotelState,
  StartUtc: IBookingState["StartUtc"],
  EndUtc: IBookingState["EndUtc"],
  VoucherCode: IBookingState["VoucherCode"]
) {
  return axios({
    method: "post",
    url: import.meta.env.VITE_MEWS_API_URL + "hotels/getAvailability",
    data: {
      Client: import.meta.env.VITE_MEWS_API_CLIENT,
      LanguageCode: Hotel.Culture.LanguageCode,
      CultureCode: Hotel.Culture.CultureCode,
      ConfigurationId: Hotel.ConfigurationId,
      CurrencyCode: Hotel.Culture.CurrencyCode,
      HotelId: Hotel.Id,
      StartUtc,
      EndUtc,
      VoucherCode: VoucherCode,
    },
  });
}

// Get Reservation price
export const getReservationPrice = (
  ConfigurationId: IHotelState["ConfigurationId"],
  CurrencyCode: IHotelState["DefaultCurrencyCode"],
  Reservations: IBookingReservation[]
) => {
  return axios({
    method: "post",
    url: import.meta.env.VITE_MEWS_API_URL + "reservations/price",
    data: {
      Client: import.meta.env.VITE_MEWS_API_CLIENT,
      ConfigurationId: ConfigurationId,
      CurrencyCode,
      Reservations,
    },
  });
};

// Get configuration
export const fetchConfiguration = (
  Hotel: IHotelState, ConfigurationId: IHotelState["ConfigurationId"]
) => {
  return axios({
    method: "post",
    url: import.meta.env.VITE_MEWS_API_URL + "configuration/get",
    data: {
      Client: import.meta.env.VITE_MEWS_API_CLIENT,
      LanguageCode: Hotel.Culture.LanguageCode,
      CultureCode: Hotel.Culture.CultureCode,
      Ids: [ConfigurationId],
      PrimaryId: ConfigurationId,
    },
  });
};

// Get current host
export const getCurrentHost = (HotelCode: IHotelState["HotelCode"]) => {
  return axios.get(
    "https://chapi.cityhub.com/api/v2/city-host/current/" + HotelCode
  );
};

export const getChapiBaseUrl = () => {
  return import.meta.env.VITE_CHAPI_URL as string;
};

export const fetchBookingPrices = () => {
  return axios.get(`${getChapiBaseUrl()}/api/v2/booking/prices`);
};
